import { useMemo } from 'react';
import { getNestedValue } from '@common/utils/getNestedValue';
import { DataEntry, FieldConfig } from '@common/components/MetadataCard';
import { DeepPath } from '@common/types/deepPath';
import { isEmpty } from '@common/utils';

export const useMetadataMapper = <T extends object>(
    source: T | undefined,
    config: FieldConfig<T>[],
    resolveLabel: (key: DeepPath<T>) => string,
): DataEntry[] => {
    return useMemo(() => {
        if (!source) return [];

        return config.map((field) => {
            const rawValue = getNestedValue(source, field.key);

            let finalValue: unknown = rawValue;

            if (!isEmpty(rawValue) && field.formatter) {
                finalValue = field.formatter(rawValue as never);
            }

            if (isEmpty(finalValue) || isEmpty(rawValue)) {
                finalValue = undefined;
            }

            return {
                label: resolveLabel(field.key),
                value: finalValue as React.ReactNode,
            };
        });
    }, [source, config, resolveLabel]);
};
